import { atom, selectorFamily } from 'recoil';
import { NormalizedUser } from '@/@types';
import { viewerIdAtom } from './globalState';

export const instructorsStateAtom = atom({
	key: 'instructorsStateAtomKey',
	default: [] as NormalizedUser[],
});
export const filteredInstructorIds = selectorFamily({
	key: 'filteredInstructorIds',
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
	get:
		(type: string) =>
		({ get }) => {
			const viewerId = get(viewerIdAtom);
			const instructors = get(instructorsStateAtom);
			if (viewerId === '') return [];
			switch (type) {
				case 'all':
					return instructors.map((i) => i.id);
				case 'ghost':
					return instructors.filter(
						(instructor: NormalizedUser) =>
							instructor.role === 'ghost'
					).map((i) => i.id);
				case 'super-ghost':
					return instructors.filter(
						(instructor: NormalizedUser) =>
							instructor.role === 'super-ghost'
					).map((i) => i.id);
				case 'invisible':
					return instructors.filter(
						(instructor: NormalizedUser) =>
							instructor.role === 'ghost' || instructor.role === 'super-ghost'
					).map((i) => i.id);
				case 'visible':
					return instructors.filter(
						(instructor: { id: string, role: string }) => instructor.id !== viewerId && instructor.role !== 'super-ghost'
					).map((i) => i.id);
				case 'forInstructor':
					return instructors.filter(
						(instructor: NormalizedUser) =>
							instructor.id !== viewerId && 
							instructor.role !== 'ghost' && 
							instructor.role !== 'super-ghost'
					).map((i) => i.id);

				case 'forStudent':
					return instructors.filter(
						(instructor: NormalizedUser) =>
							instructor.id !== viewerId && instructor.role !== 'ghost' && instructor.role !== 'super-ghost'
					).map((i) => i.id);
				case 'forStudentIds':
					return instructors
						.filter(
							(instructor: NormalizedUser) =>
								instructor.id !== viewerId && instructor.role !== 'ghost' && instructor.role !== 'super-ghost'
						)
						.map((i) => i.id);
				default:
					throw new Error(
						`filteredInstructors selector famility Invalid type: ${type}`
					);
			}
		},
});

export const filteredInstructors = selectorFamily({
	key: 'filteredInstructors',
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
	get:
		(type: string) =>
		({ get }) => {
			const viewerId = get(viewerIdAtom);
			const instructors = get(instructorsStateAtom);
			if (viewerId === '') return [];
			switch (type) {
				case 'all':
					return instructors;
				case 'invisible':
					return instructors.filter(
						(instructor: NormalizedUser) =>
							instructor.role === 'ghost' || instructor.role === 'super-ghost'
					).map((i) => i.id);
				case 'visible':
					return instructors.filter(
						(instructor: { id: string, role: string }) => instructor.id !== viewerId && instructor.role !== 'super-ghost'
					);
				case 'forInstructor':
					return instructors.filter(
						(instructor: NormalizedUser) =>
							instructor.id !== viewerId && 
							instructor.role !== 'ghost' && 
							instructor.role !== 'super-ghost'
					);

				case 'forStudent':
					return instructors.filter(
						(instructor: NormalizedUser) =>
							instructor.id !== viewerId && instructor.role !== 'ghost' && instructor.role !== 'super-ghost'
					);
				case 'forStudentIds':
					return instructors
						.filter(
							(instructor: NormalizedUser) =>
								instructor.id !== viewerId && instructor.role !== 'ghost' && instructor.role !== 'super-ghost'
						)
						.map((i) => i.id);
				default:
					throw new Error(
						`filteredInstructors selector famility Invalid type: ${type}`
					);
			}
		},
});
